import React from 'react';
import DeviceInfo from './components/DeviceInfo';

const DevicesDetailView = () => <DeviceInfo />;

export default DevicesDetailView;
